<template>
    <modal v-if="showModal" @close="$emit('closeModal')"  class="vibarua-model">
        <template slot="header">
            <h4 class="modal-title">{{title}}</h4>
            <md-button
                    class="md-simple md-just-icon md-round modal-default-button"
                    @click="$emit('closeModal')">
                <md-icon>clear</md-icon>
            </md-button>
        </template>

        <template slot="body">
            <multiselect
                    v-model="selected"
                    deselect-label="Can't remove this value"
                    track-by="name"
                    :multiple="multiple"
                    label="name"
                    placeholder="Select Permission to Add"
                    :options="permissions"
                    :searchable="true"
                    :allow-empty="false"
                    >
            </multiselect>
        </template>

        <template slot="footer">
            <md-button class="md-simple" @click="$emit('addPermissions',selected)">Add Selected Permission</md-button>
            <md-button
                    class="md-danger md-simple"
                    @click="$emit('closeModal')">Close
            </md-button>
        </template>
    </modal>
</template>

<script>
import {
    Modal
} from '@/components';
import Multiselect from 'vue-multiselect';

export default {
    name: 'AddPermissionModal',
    components: { Modal, Multiselect },
    props:{
        title:{
            type:String,default:'add permission'
        },
        showModal:{
            type:Boolean,default: false
        },
        multiple:{
            type:Boolean,default: true
        }
    },
    data () {
        return {
            'permissions':[],
            selected:[]
        };
    },
    created () {
        this.fetchData();
    },
    methods:{
        async fetchData () {
            await this.$store.dispatch('permissions/list');
            this.permissions = this.$store.getters['permissions/list'];
        }
    }
};
</script>

<style scoped>
.vibarua-model .modal-wrapper .modal-container{
    min-height: 250px;
}
</style>
